<template>
	<div class="subscriberDialog">
		<el-dialog title="订阅器" v-bind="$attrs" v-on="$listeners" width="50%">
			<template v-if="info">
				<div class="item">
					<div class="title">订阅器名称：</div>
					<div class="item-content">{{ info.name }}</div>
				</div>
				<div class="item">
					<div class="title">采购方式：</div>
					<div class="item-content label">
						<template v-if="info.purchaseVO && info.purchaseVO.length">
							<el-tag v-for="item in info.purchaseVO" :key="item.value" type="warning" effect="plain">
								{{ item.value }}
							</el-tag>
						</template>
						<!-- <template v-else>无</template> -->
						<template v-else>全部</template>
					</div>
				</div>
				<div class="item">
					<div class="title">公告类型：</div>
					<div class="item-content label">
						<template v-if="info.announcementVO && info.announcementVO.length">
							<el-tag v-for="item in info.announcementVO" :key="item.value" type="warning" effect="plain">
								{{ item.value }}
							</el-tag>
						</template>
						<!-- <template v-else>无</template> -->
						<template v-else>全部</template>
					</div>
				</div>
				<div class="item">
					<div class="title">关键词：</div>
					<div class="item-content label">
						<el-tag v-for="item in info.keywordVO" :key="item.value" type="warning" effect="plain">
							{{ item.value }}
						</el-tag>
					</div>
				</div>
				<div class="item">
					<div class="title">选择地区：</div>
					<div class="item-content label">
						<template v-if="info.regionNameVO && info.regionNameVO.length">
							<el-tag v-for="item in info.regionNameVO" :key="item.value" type="warning" effect="plain">
								{{ item.value }}
							</el-tag>
						</template>
						<el-tag type="warning" effect="plain" v-else>全国</el-tag>
					</div>
				</div>
				<div class="item">
					<div class="title">项目金额：</div>
					<div class="item-content">
						<div v-if="!info.minMoney && !info.maxMoney">不限</div>
						<!-- <div v-else-if="info.minMoney > 0 && info.maxMoney==null">{{ info.minMoney / 1000000 }}万元以上</div>
						<div v-else>{{ info.minMoney / 1000000 }}{{ info.maxMoney / 1000000 }}万元以上</div> -->
						<div v-else-if="info.minMoney == 0 && info.maxMoney / 1000000 == 100">{{ info.maxMoney / 1000000 }}万元以下</div>
						<div v-else-if="info.minMoney > 0 && info.maxMoney == null">{{ info.minMoney / 10000000000 }}亿元以上</div>
						<div v-else-if="info.minMoney / 1000000 == 5000 && info.maxMoney / 1000000 == 10000">{{ info.minMoney / 1000000
						}} - {{ info.maxMoney / 10000000000 }}亿元</div>
						<div v-else>{{ info.minMoney / 1000000 }} - {{ info.maxMoney / 1000000 }}万元</div>
					</div>
				</div>
				<div class="item">
					<div class="title">接收频率：</div>
					<div class="item-content">{{ info.pushMode ? '即时推送' : '定时推送' }} {{ info.pushHour }} 点</div>
				</div>
				<div class="item">
					<div class="title">接收方式：</div>
					<div class="item-content">
						<template v-for="item in info.modeVO">
							<template v-if="item.subscribeMode == 0">消息中心 </template>
							<template v-if="item.subscribeMode == 3">| 微信公众号推送 </template>
							<template v-if="item.subscribeMode == 1">| 电子邮件:{{ item.modeValue }} </template>
							<template v-if="item.subscribeMode == 2">| 接收手机号:{{ item.modeValue }} </template>

						</template>
					</div>
				</div>
				<div class="item" v-if="info.wxUserInfo">
					<div class="title">推送微信：</div>
					<div class="item-content" v-if="info.wxUserInfo">
						<el-avatar shape="square" size="small" :src="info.wxUserInfo.headImgUrl"></el-avatar>
						{{ info.wxUserInfo.nickname }}
					</div>
				</div>
				<div class="item">
					<div class="title">到期时间：</div>
					<div class="item-content">{{ info.dueTime }}</div>
				</div>
			</template>

		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "subscriberDialog",
	props: ["info"],
	created() {

	},
	mounted() {
	}
}
</script>

<style scoped lang="less">
.item {
	display: flex;
	align-items: center;
}

.item+.item {
	margin-top: 20px;
}

.title {
	text-align: right;
	width: 150px;
}

.item-content {
	padding-left: 10px;
}

.label {
	display: flex;
	flex: 1;
	flex-wrap: wrap;
	gap: 10px;
}
</style>
